import { render, staticRenderFns } from "./UnitItem.vue?vue&type=template&id=4f2e235c"
import script from "./UnitItem.vue?vue&type=script&lang=js"
export * from "./UnitItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports